/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".countdown[_ngcontent-%COMP%]{text-align:center;color:red;width:100%}img[_ngcontent-%COMP%]{width:100%}.maintenance[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-direction:column}.card[_ngcontent-%COMP%]{margin-top:10rem;border:none}"];
export { styles as styles };
